/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WaitingPatientAppointmentResponse } from './WaitingPatientAppointmentResponse';
import {
    WaitingPatientAppointmentResponseFromJSON,
    WaitingPatientAppointmentResponseFromJSONTyped,
    WaitingPatientAppointmentResponseToJSON,
    WaitingPatientAppointmentResponseToJSONTyped,
} from './WaitingPatientAppointmentResponse';
import type { InstituteRoomBadge } from './InstituteRoomBadge';
import {
    InstituteRoomBadgeFromJSON,
    InstituteRoomBadgeFromJSONTyped,
    InstituteRoomBadgeToJSON,
    InstituteRoomBadgeToJSONTyped,
} from './InstituteRoomBadge';

/**
 * Response representing a waiting room and its occupants
 * @export
 * @interface WaitingPatientsResponse
 */
export interface WaitingPatientsResponse {
    /**
     * Name of the waiting room
     * @type {string}
     * @memberof WaitingPatientsResponse
     */
    roomName: string;
    /**
     * Unique identifier for rooms which are not declared on-the-fly
     * @type {string}
     * @memberof WaitingPatientsResponse
     */
    roomId?: string;
    /**
     * 
     * @type {InstituteRoomBadge}
     * @memberof WaitingPatientsResponse
     */
    roomBadge?: InstituteRoomBadge;
    /**
     * Persons who currently are in the waiting room
     * @type {Array<WaitingPatientAppointmentResponse>}
     * @memberof WaitingPatientsResponse
     */
    occupants: Array<WaitingPatientAppointmentResponse>;
}

/**
 * Check if a given object implements the WaitingPatientsResponse interface.
 */
export function instanceOfWaitingPatientsResponse(value: object): value is WaitingPatientsResponse {
    if (!('roomName' in value) || value['roomName'] === undefined) return false;
    if (!('occupants' in value) || value['occupants'] === undefined) return false;
    return true;
}

export function WaitingPatientsResponseFromJSON(json: any): WaitingPatientsResponse {
    return WaitingPatientsResponseFromJSONTyped(json, false);
}

export function WaitingPatientsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WaitingPatientsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'roomName': json['roomName'],
        'roomId': json['roomId'] == null ? undefined : json['roomId'],
        'roomBadge': json['roomBadge'] == null ? undefined : InstituteRoomBadgeFromJSON(json['roomBadge']),
        'occupants': ((json['occupants'] as Array<any>).map(WaitingPatientAppointmentResponseFromJSON)),
    };
}

export function WaitingPatientsResponseToJSON(json: any): WaitingPatientsResponse {
    return WaitingPatientsResponseToJSONTyped(json, false);
}

export function WaitingPatientsResponseToJSONTyped(value?: WaitingPatientsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roomName': value['roomName'],
        'roomId': value['roomId'],
        'roomBadge': InstituteRoomBadgeToJSON(value['roomBadge']),
        'occupants': ((value['occupants'] as Array<any>).map(WaitingPatientAppointmentResponseToJSON)),
    };
}

